import { create } from 'zustand'

const STORAGE_KEY = 'jdh:current-kitchen:v1'

interface KitchenContext {
  slug: string
  name: string
  brandPrimary: string | null
}

function storedKitchen(): KitchenContext {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const value = JSON.parse(raw) as Partial<KitchenContext>
      if (typeof value.slug === 'string' && typeof value.name === 'string') {
        return {
          slug: value.slug,
          name: value.name,
          brandPrimary:
            typeof value.brandPrimary === 'string' ? value.brandPrimary : null,
        }
      }
    }
  } catch {
    // Storage is an optional navigation convenience, never an authority.
  }
  return { slug: 'morning-bowl-co', name: 'Your kitchen', brandPrimary: null }
}

interface KitchenState extends KitchenContext {
  setKitchen: (kitchen: {
    slug: string
    name: string
    brandPrimary?: string | null
  }) => void
}

export const useKitchenStore = create<KitchenState>((set, get) => ({
  ...storedKitchen(),
  setKitchen: (kitchen) => {
    const previous = get()
    const next: KitchenContext = {
      slug: kitchen.slug,
      name: kitchen.name,
      // An update without brand info keeps the known brand for the same
      // kitchen but never carries one kitchen's brand onto another.
      brandPrimary:
        kitchen.brandPrimary !== undefined
          ? kitchen.brandPrimary
          : kitchen.slug === previous.slug
            ? previous.brandPrimary
            : null,
    }
    set(next)
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    } catch {
      // The active route still works when storage is unavailable.
    }
  },
}))
